import Vue from 'vue'

import CorePageTitle from '@/components/admin/core/CorePageTitle'

Vue.component('core-page-title', CorePageTitle)
